module.exports = __webpack_public_path__ + "img/facade-hamptons-single.1d4dc827.jpeg";